<a href="{{navigate}}">
  <ng-content select=".descricao"></ng-content>
  <ng-content select="p.titulovalor"></ng-content>
  <ng-content select=".vencimento"></ng-content>
</a>
